import quickFetch from 'quick-fetch';
import { getApiUrl } from '../utils/urls';
export const CONFIG_EARLY_REQUEST = 'CONFIG_EARLY_REQUEST';
export const configEarlyRequest = () => {
  const path = window.location.pathname;
  const slug = path.split('/').pop() || '';
  if (path.includes('verify') || path.includes('preview') || !slug || slug === 'request') {
    return;
  }
  quickFetch.makeEarlyRequest(CONFIG_EARLY_REQUEST, {
    url: `${getApiUrl()}/${slug}`,
    type: 'GET',
    dataType: 'json'
  });
};